import { useState } from "react";

/**
 * Runs `reset` during RENDER when `open` turns true, off the previous `open`: React's documented
 * way to reset state when a prop changes. An effect would do the same work one paint later, so
 * the last person's input would flash by, and `react-hooks/set-state-in-effect` refuses it for
 * exactly that reason. Used by the dialogs that open empty every time.
 */
export function useResetOnOpen(open: boolean, reset: () => void): void {
  const [wasOpen, setWasOpen] = useState(open);
  if (wasOpen !== open) {
    setWasOpen(open);
    if (open) reset();
  }
}
